import type { OptimizerResult } from "@/types/feeds";
import { normalizeFantasySportsbookId } from "@/types/feeds";

export const isDevEnvironment = process.env.NODE_ENV !== "production";

export const toFiniteNumber = (value: unknown): number | null => {
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === "string") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
};

export function selectFantasyBookId(result: OptimizerResult): string {
  const raw =
    result.sportsbook ??
    result.fantasy_sportsbook ??
    "";
  return normalizeFantasySportsbookId(raw) || "prizepicks";
}

export function selectFantasyOdds(result: OptimizerResult): number | null {
  return toFiniteNumber(
    result.sportsbook_american_odds ?? result.fantasy_american_odds,
  );
}
